/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import BannerCta from "./BannerCta.container";

export default BannerCta;
